(()=>{
  if(window.__imperialWatchGeneralTrackingBound)return;
  window.__imperialWatchGeneralTrackingBound=true;

  const clean=v=>String(v??'').replace(/\s+/g,' ').trim();
  const push=(event,payload={})=>{
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event,...payload});
  };
  const discoveryContext=()=>document.querySelector('[data-imperial-discovery-context]')?.dataset.imperialDiscoveryContext||'';
  const collectionContext=()=>{
    const context=discoveryContext();
    return ['collection-watches','collection-rolex'].includes(context)?context:'';
  };
  const watchRoot=el=>el?.closest?.('[data-imperial-watch-pdp]')||document.querySelector('[data-imperial-watch-pdp]');
  const pdpPayload=el=>{
    const root=watchRoot(el);
    if(!root)return{};
    return{
      item_name:clean(root.dataset.productTitle),
      product_url:clean(root.dataset.productUrl)||`${location.origin}${location.pathname}`,
      reference:clean(root.dataset.productReference),
      section_id:clean(root.dataset.sectionId)
    };
  };
  const actionEvents={
    whatsapp:'whatsapp_specialist_click',
    'source-model':'whatsapp_specialist_click',
    appointment:'book_viewing_click',
    'part-exchange':'part_exchange_click',
    'sell-part-exchange':'part_exchange_click',
    'additional-media':'request_media_click'
  };

  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null;
    if(!target)return;

    const offer=target.closest('[data-imperial-offer-open]');
    if(offer)push('make_offer_open',{...pdpPayload(offer),action_text:clean(offer.textContent)});

    const action=target.closest('[data-watch-action]');
    if(action){
      const eventName=actionEvents[action.dataset.watchAction];
      if(eventName)push(eventName,{...pdpPayload(action),action_text:clean(action.textContent),action_key:clean(action.dataset.watchAction)});
    }

    const productLink=target.closest('[data-imperial-list-item] a[href*="/products/"]');
    if(productLink&&!target.closest('[data-imperial-source-another]')){
      const item=productLink.closest('[data-imperial-list-item]');
      let productUrl='';
      try{const u=new URL(productLink.getAttribute('href'),location.origin);productUrl=`${u.origin}${u.pathname}`;}catch(e){}
      push('collection_product_click',{
        item_id:clean(item?.dataset.itemId),
        item_name:clean(item?.dataset.itemName)||clean(productLink.textContent),
        item_brand:clean(item?.dataset.itemBrand),
        item_category:clean(item?.dataset.itemCategory),
        item_list_name:clean(item?.dataset.itemListName),
        item_list_id:clean(item?.dataset.itemListId),
        index:item?.dataset.itemIndex===''||item?.dataset.itemIndex==null?undefined:Number(item.dataset.itemIndex),
        price:item?.dataset.itemPrice===''||item?.dataset.itemPrice==null?undefined:Number(item.dataset.itemPrice),
        currency:clean(item?.dataset.itemCurrency),
        product_url:productUrl
      });
    }

    const context=collectionContext();
    if(context){
      const clearAll=target.closest('a.active-facets__button-remove,.mobile-facets__clear');
      const removeFacet=clearAll?null:target.closest('a.active-facets__button');
      const facetAction=clearAll||removeFacet;
      if(facetAction){
        push('collection_filter',{
          collection_context:context.replace('collection-',''),
          filter_action:clearAll?'clear_all':'remove',
          filter_label:clean(facetAction.textContent),
          filter_name:'',
          filter_value:''
        });
      }
    }
  },true);

  document.addEventListener('submit',event=>{
    const form=event.target instanceof HTMLFormElement?event.target:null;
    if(form?.matches('.imperial-offer-form'))push('make_offer_submit',pdpPayload(form));
  },true);

  document.addEventListener('change',event=>{
    const context=collectionContext();
    if(!context)return;
    const el=event.target instanceof Element?event.target:null;
    if(!el?.matches('#FacetFiltersForm input,#FacetFiltersForm select,#FacetFiltersFormMobile input,#FacetFiltersFormMobile select,#FacetSortForm input,#FacetSortForm select,#FacetSortDrawerForm input,#FacetSortDrawerForm select'))return;
    const details=el.closest('details');
    const label=clean(details?.querySelector('summary span')?.textContent)||clean(el.getAttribute('aria-label'))||clean(el.name);
    push('collection_filter',{
      collection_context:context.replace('collection-',''),
      filter_action:'change',
      filter_name:clean(el.name),
      filter_label:label,
      filter_value:clean(el.value),
      checked:'checked' in el?Boolean(el.checked):undefined
    });
  },true);
})();